import React,{useState, useEffect} from "react";
import { isAuthenticated } from "../../../auth";

const Parameter = (props) => {

  const {user,token} = isAuthenticated();
  const [ParameterType, setParameterType] = useState();

  const handleParameterType = (value) => {
    setParameterType(value);
    props.handleParameterType(value);
  }

  useEffect(() => {
    if(props.getParameterType){
      setParameterType(props.getParameterType);
    }
  },[props])

  return(
    <div className="w-full">
      <p className="fs-16 m-b-12 font-weight-700 color-black">Parameter Type</p>
      {
        user.role == 0 && (
          <div className="w-full">
            <div className="d-flex">
              <input onClick={()=>handleParameterType("exerciseLevel")} type="radio" name="user-type" checked={ParameterType == "exerciseLevel"} className='flex-item cursor-pointer m-r-6 m-b-12' style={{width:"20px", height:"20px"}} />
              <p className='fs-16 font-weight-600'>Exercise Level</p>
            </div>
            <div className="d-flex">
              <input onClick={()=>handleParameterType("targetMuscle")} type="radio" name="user-type" checked={ParameterType == "targetMuscle"} className='flex-item cursor-pointer m-r-6 m-b-12' style={{width:"20px", height:"20px"}} />
              <p className='fs-16 font-weight-600'>Target Muscles</p>
            </div>
            <div className="d-flex">
              <input onClick={()=>handleParameterType("exerciseName")} type="radio" name="user-type" checked={ParameterType == "exerciseName"} className='flex-item cursor-pointer m-r-6 m-b-12' style={{width:"20px", height:"20px"}} />
              <p className='fs-16 font-weight-600'>Exercise Name</p>
            </div>
            <div className="d-flex">
              <input onClick={()=>handleParameterType("gosFeature")} type="radio" name="user-type" checked={ParameterType == "gosFeature"} className='flex-item cursor-pointer m-r-6 m-b-12' style={{width:"20px", height:"20px"}} />
              <p className='fs-16 font-weight-600'>GOS Feature</p>
            </div>
            <div className="d-flex">
              <input onClick={()=>handleParameterType("workoutPlusFeature")} type="radio" name="user-type" checked={ParameterType == "workoutPlusFeature"} className='flex-item cursor-pointer m-r-6 m-b-12' style={{width:"20px", height:"20px"}} />
              <p className='fs-16 font-weight-600'>Workout Plus Feature</p>
            </div>
            <div className="d-flex">
              <input onClick={()=>handleParameterType("appointmentType")} type="radio" name="user-type" checked={ParameterType == "appointmentType"} className='flex-item cursor-pointer m-r-6 m-b-12' style={{width:"20px", height:"20px"}} />
              <p className='fs-16 font-weight-600'>Appointment Type</p>
            </div>
            <div onClick={()=>handleParameterType("member-goal")} className="d-flex">
              <input type="radio" name="user-type" checked={ParameterType == "member-goal"} className='flex-item cursor-pointer m-r-6 m-b-12' style={{width:"20px", height:"20px"}}  />
              <p className='fs-16 font-weight-600'>Member Goal</p>
            </div>
          </div>
        )
      }
      {
        (user.role == 0 || user.role == 5) && [
          <div onClick={()=>handleParameterType("expenseType")} className="d-flex">
            <input type="radio" name="user-type" checked={ParameterType == "expenseType"} className='flex-item cursor-pointer m-r-6 m-b-12' style={{width:"20px", height:"20px"}} />
            <p className='fs-16 font-weight-600'>Expense Type</p>
          </div>
        ]
      }
      
    </div>
  )
}

export default Parameter;